import { ReactNode } from 'react'

import { useCompleteSignupNudge } from './complete-signup-nudge-context'
import { NudgePopover } from './nudge-popover'

export function CompleteSignupNudgeAvatarSlot({ children }: { children: ReactNode }) {
  const nudge = useCompleteSignupNudge()

  if (!nudge?.showPopover) return <>{children}</>

  return (
    <NudgePopover onComplete={nudge.openModal} onDismiss={nudge.dismiss}>
      {children}
    </NudgePopover>
  )
}
